export const environment = {
  production: true,
  apiUrl: 'https://nisargopacharashram.org/carme/api/' // New Domains
  // apiUrl: 'https://test.epionhealth.in/carme/api/' // Test Domains
  // apiUrl: 'https://demo.epionhealth.in/carme/api/' // Other Test Domains
  // apiUrl: 'https://ncaweb.epionhealth.in/carme/api/' // Test Domains
  // ng build --aot --watch --configuration --outputHashing=all
};
